import React from "react";
import { BellRing, Check } from "lucide-react";

// Aviso flutuante de mesa chamando. Fica por cima de qualquer tela do painel,
// junto com o som, e só sai quando alguém toca em Atendido.
export default function ChamadoGarcomBanner({ chamados, onAtender }) {
  if (!chamados || chamados.length === 0) return null;
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[70] w-[min(92vw,420px)] space-y-2">
      {chamados.slice(0, 3).map((chamado) => (
        <div
          key={chamado.mesa_id}
          data-e2e="chamado-garcom"
          className="flex items-center gap-3 rounded-2xl bg-amber-500 text-white px-4 py-3 shadow-2xl animate-pulse-slow"
        >
          <BellRing className="w-5 h-5 shrink-0 animate-bounce" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-black truncate">{chamado.nome} está chamando</p>
            {chamado.quem ? (
              <p className="text-[11px] opacity-90 truncate">{chamado.quem}</p>
            ) : null}
          </div>
          <button
            type="button"
            onClick={() => onAtender(chamado.mesa_id)}
            className="shrink-0 flex items-center gap-1 rounded-full bg-white/95 text-amber-600 px-3 py-1.5 text-xs font-black active:scale-95 transition"
          >
            <Check className="w-3.5 h-3.5" /> Atendido
          </button>
        </div>
      ))}
      {chamados.length > 3 ? (
        <p className="text-center text-xs font-bold text-amber-600">
          e mais {chamados.length - 3} mesa(s) chamando
        </p>
      ) : null}
    </div>
  );
}
